import React from 'react';
import './Skeleton.css';

export const Skeleton = ({ width, height, borderRadius = '8px', className = '' }) => {
  return (
    <div
      className={`skeleton-base ${className}`}
      style={{ width, height, borderRadius }}
    />
  );
};

export const CourseCardSkeleton = () => (
  <div className="skeleton-card">
    <Skeleton height="160px" borderRadius="12px 12px 0 0" />
    <div style={{ padding: '16px' }}>
      <Skeleton width="40%" height="18px" className="mb-8" />
      <Skeleton width="90%" height="22px" className="mb-12" />
      <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
        <Skeleton width="24px" height="24px" borderRadius="50%" />
        <Skeleton width="50%" height="14px" />
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '16px' }}>
        <Skeleton width="30%" height="20px" />
        <Skeleton width="20%" height="16px" />
      </div>
    </div>
  </div>
);
